type IconProps = {
  className?: string
  spinning?: boolean
}

export function Calculator3DIcon({ className = '' }: IconProps) {
  return (
    <svg className={`ops-3d-svg ${className}`} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id="opsCalcBody" x1="7" y1="4" x2="25" y2="28" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#d9f3ff" />
          <stop offset=".22" stopColor="#75c6ff" />
          <stop offset=".58" stopColor="#2878ca" />
          <stop offset="1" stopColor="#113a73" />
        </linearGradient>
        <linearGradient id="opsCalcScreen" x1="10" y1="8" x2="22" y2="13" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#effcff" />
          <stop offset="1" stopColor="#9bdfff" />
        </linearGradient>
        <filter id="opsCalcShadow" x="-40%" y="-30%" width="180%" height="190%">
          <feDropShadow dx="0" dy="2.4" stdDeviation="1.8" floodColor="#082746" floodOpacity=".52" />
        </filter>
      </defs>
      <g filter="url(#opsCalcShadow)">
        <rect x="6.2" y="3.7" width="19.6" height="24.6" rx="5" fill="url(#opsCalcBody)" stroke="#e8f7ff" strokeOpacity=".72" strokeWidth="1" />
        <rect x="9.1" y="7.4" width="13.8" height="6.1" rx="1.7" fill="url(#opsCalcScreen)" stroke="#0f4e87" strokeOpacity=".58" strokeWidth=".8" />
        <path d="M10 6.1c2.7-1.2 8.3-1.8 12.1-.4" fill="none" stroke="#fff" strokeOpacity=".58" strokeWidth="1" strokeLinecap="round" />
        {[
          [10.4, 17.1], [16, 17.1], [21.6, 17.1],
          [10.4, 21.7], [16, 21.7], [21.6, 21.7]
        ].map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r="1.55" fill={i === 2 || i === 5 ? '#a8ecff' : '#eaf7ff'} stroke="#15528c" strokeOpacity=".7" strokeWidth=".55" />
        ))}
      </g>
    </svg>
  )
}

export function Calendar3DIcon({ className = '' }: IconProps) {
  return (
    <svg className={`ops-3d-svg ${className}`} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id="opsCalBody" x1="6" y1="6" x2="26" y2="27" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f7fdff" />
          <stop offset=".5" stopColor="#c4e8ff" />
          <stop offset="1" stopColor="#6ca9db" />
        </linearGradient>
        <linearGradient id="opsCalTop" x1="6" y1="6" x2="26" y2="13" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#8de8ff" />
          <stop offset=".48" stopColor="#42a9ed" />
          <stop offset="1" stopColor="#2461af" />
        </linearGradient>
        <filter id="opsCalShadow" x="-40%" y="-30%" width="180%" height="190%">
          <feDropShadow dx="0" dy="2.4" stdDeviation="1.8" floodColor="#12375d" floodOpacity=".48" />
        </filter>
      </defs>
      <g filter="url(#opsCalShadow)">
        <rect x="5.3" y="6.2" width="21.4" height="21" rx="4.3" fill="url(#opsCalBody)" stroke="#eaf7ff" strokeOpacity=".9" strokeWidth="1" />
        <path d="M5.3 10.2c0-2.2 1.8-4 4-4h13.4c2.2 0 4 1.8 4 4v3H5.3v-3Z" fill="url(#opsCalTop)" />
        <path d="M9.5 5v4M22.5 5v4" stroke="#ecfbff" strokeWidth="2" strokeLinecap="round" />
        <path d="M8.5 15.8h15M8.5 20h15M8.5 24.2h10.5" stroke="#2c6fa8" strokeOpacity=".55" strokeWidth="1.15" strokeLinecap="round" />
        <path d="M8 8.2c3.7-1 10.6-1.2 15.5-.25" fill="none" stroke="#fff" strokeOpacity=".5" strokeWidth=".9" strokeLinecap="round" />
      </g>
    </svg>
  )
}

export function McpRefresh3DIcon({ className = '', spinning = false }: IconProps) {
  return (
    <svg className={`ops-3d-svg ${spinning ? 'ops-3d-spin' : ''} ${className}`} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <radialGradient id="opsMcpCore" cx="38%" cy="30%" r="70%">
          <stop offset="0" stopColor="#efffff" />
          <stop offset=".28" stopColor="#67ecff" />
          <stop offset=".66" stopColor="#1ca7dc" />
          <stop offset="1" stopColor="#0c4f8f" />
        </radialGradient>
        <linearGradient id="opsMcpRing" x1="7" y1="5" x2="25" y2="27" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#c4f7ff" />
          <stop offset=".45" stopColor="#52c7f4" />
          <stop offset="1" stopColor="#3257bd" />
        </linearGradient>
        <filter id="opsMcpShadow" x="-45%" y="-45%" width="190%" height="200%">
          <feDropShadow dx="0" dy="2.4" stdDeviation="1.7" floodColor="#07365e" floodOpacity=".55" />
          <feDropShadow dx="0" dy="0" stdDeviation="1.8" floodColor="#36d9ff" floodOpacity=".26" />
        </filter>
      </defs>
      <g filter="url(#opsMcpShadow)">
        <circle cx="16" cy="16" r="4.9" fill="url(#opsMcpCore)" stroke="#dffcff" strokeOpacity=".85" strokeWidth=".8" />
        <path d="M8.1 19.2A8.6 8.6 0 0 1 19.3 8.1" fill="none" stroke="url(#opsMcpRing)" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M23.9 12.8A8.6 8.6 0 0 1 12.7 23.9" fill="none" stroke="url(#opsMcpRing)" strokeWidth="2.4" strokeLinecap="round" />
        <path d="m18.4 6.9 2.2 1.1-1.5 2" fill="none" stroke="#eaffff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="m13.6 25.1-2.2-1.1 1.5-2" fill="none" stroke="#eaffff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="8.1" cy="19.2" r="1.25" fill="#9ef5ff" />
        <circle cx="23.9" cy="12.8" r="1.25" fill="#9ef5ff" />
      </g>
    </svg>
  )
}

export function GlobalRefresh3DIcon({ className = '', spinning = false }: IconProps) {
  return (
    <svg className={`ops-3d-svg ${spinning ? 'ops-3d-spin' : ''} ${className}`} viewBox="0 0 32 32" aria-hidden="true">
      <defs>
        <linearGradient id="opsRefreshMetal" x1="6" y1="5" x2="26" y2="27" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#eff9ff" />
          <stop offset=".27" stopColor="#9fd5ff" />
          <stop offset=".58" stopColor="#3d88d2" />
          <stop offset="1" stopColor="#1b477f" />
        </linearGradient>
        <filter id="opsRefreshShadow" x="-45%" y="-45%" width="190%" height="200%">
          <feDropShadow dx="0" dy="2.4" stdDeviation="1.7" floodColor="#0d2c4e" floodOpacity=".5" />
        </filter>
      </defs>
      <g filter="url(#opsRefreshShadow)" fill="none" stroke="url(#opsRefreshMetal)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M24.4 11.2A10 10 0 0 0 7.8 9.6L5.9 12" />
        <path d="m5.9 12 .4-5 4.8.8" />
        <path d="M7.6 20.8a10 10 0 0 0 16.6 1.6l1.9-2.4" />
        <path d="m26.1 20-.4 5-4.8-.8" />
      </g>
      <path d="M8.1 8.9c3.5-3.1 9.2-3.7 13.3-1.1" fill="none" stroke="#fff" strokeOpacity=".6" strokeWidth=".8" strokeLinecap="round" />
    </svg>
  )
}

export function DayNight3DSwitch({ theme, className = '' }: { theme: string; className?: string }) {
  const state = theme === 'dark' ? 'dark' : theme === 'light' ? 'light' : 'auto'
  return (
    <span className={`ops-daynight-switch ops-daynight-${state} ${className}`} aria-hidden="true">
      <span className="ops-daynight-sun">
        <svg viewBox="0 0 18 18">
          <defs>
            <radialGradient id="opsSunSphere" cx="35%" cy="28%" r="72%">
              <stop offset="0" stopColor="#fffbd0" />
              <stop offset=".38" stopColor="#ffd963" />
              <stop offset="1" stopColor="#e38b13" />
            </radialGradient>
          </defs>
          <circle cx="9" cy="9" r="3.3" fill="url(#opsSunSphere)" />
          <g stroke="#ffd85a" strokeWidth="1.25" strokeLinecap="round">
            <path d="M9 1.5v2M9 14.5v2M1.5 9h2M14.5 9h2M3.7 3.7l1.4 1.4M12.9 12.9l1.4 1.4M14.3 3.7l-1.4 1.4M5.1 12.9l-1.4 1.4" />
          </g>
        </svg>
      </span>
      <span className="ops-daynight-moon">
        <svg viewBox="0 0 18 18">
          <defs>
            <linearGradient id="opsMoonSphere" x1="4" y1="3" x2="14" y2="15" gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#edf1ff" />
              <stop offset=".45" stopColor="#a9b8f0" />
              <stop offset="1" stopColor="#5d6eb5" />
            </linearGradient>
          </defs>
          <path d="M12.8 13.1A6.1 6.1 0 1 1 9.7 3.2c-1.2 4.4.2 7.7 3.1 9.9Z" fill="url(#opsMoonSphere)" stroke="#eef3ff" strokeOpacity=".7" strokeWidth=".5" />
        </svg>
      </span>
      <span className="ops-daynight-thumb" />
    </span>
  )
}
